export default __webpack_public_path__ + "static/media/cloud.fbc9fe7a.png";